import { reportWarn } from '../owl'

export function isErrorMessage(err: any): err is { message: string } {
  return 'message' in err
}

export const JSONparse = function (originValue: string, defaultValue = {}) {
  try {
    return JSON.parse(originValue)
  } catch (err) {
    reportWarn({
      name: 'JSON.parse Error' + (isErrorMessage(err) && err.message),
      global: true,
      msg: originValue,
    })
    return defaultValue
  }
}

export const setLocalStorage = function (key: string, value: boolean | number | string | object) {
  try {
    let strValue: string | undefined
    if (Object.prototype.toString.call(value) === '[object Object]') {
      strValue = JSON.stringify(value)
    } else if (typeof value === 'string' || typeof value === 'number') {
      strValue = String(value)
    } else if (typeof value === 'boolean') {
      strValue = value ? '1' : '0'
    }
    if (strValue) {
      localStorage.setItem(key, strValue)
    } else {
      localStorage.removeItem(key)
    }
  } catch (err) {
    reportWarn({
      name: 'localStorage.setItem',
      global: true,
      msg: err,
    })
  }
}

export const getLocalStorage = function (key: string, type = 'String', defaultValue?: any) {
  try {
    const originValue = localStorage.getItem(key)
    if (originValue) {
      switch (type) {
        case 'Number':
          return Number(originValue)
        case 'Object':
          return JSONparse(originValue, defaultValue)
        case 'Boolean':
          return originValue === '0' ? false : true
        default:
          return originValue
      }
    }
    return defaultValue
  } catch (err) {
    reportWarn({
      name: 'localStorage.getItem',
      global: true,
      msg: err,
    })
    return defaultValue
  }
}

export function removeLocalStorage(key: string) {
  try {
    localStorage.removeItem(key)
  } catch (err) {
    reportWarn({
      name: 'localStorage.removeItem',
      global: true,
      msg: err,
    })
  }
}

export const setSessionStorage = function (key: string, value: boolean | number | string | object) {
  try {
    let strValue: string | undefined
    if (Object.prototype.toString.call(value) === '[object Object]') {
      strValue = JSON.stringify(value)
    } else if (typeof value === 'string' || typeof value === 'number') {
      strValue = String(value)
    } else if (typeof value === 'boolean') {
      strValue = value ? '1' : '0'
    }
    if (strValue) {
      sessionStorage.setItem(key, strValue)
    } else {
      sessionStorage.removeItem(key)
    }
  } catch (err) {
    reportWarn({
      name: 'sessionStorage.setItem',
      global: true,
      msg: err,
    })
  }
}

export const getSessionStorage = function (key: string, type = 'String', defaultValue?: any) {
  try {
    const originValue = sessionStorage.getItem(key)
    if (originValue) {
      switch (type) {
        case 'Number':
          return Number(originValue)
        case 'Object':
          return JSONparse(originValue, defaultValue)
        case 'Boolean':
          return originValue === '0' ? false : true
        default:
          return originValue
      }
    }
    return defaultValue
  } catch (err) {
    reportWarn({
      name: 'sessionStorage.getItem',
      global: true,
      msg: err,
    })
    return defaultValue
  }
}

export function removeSessionStorage(key: string) {
  try {
    sessionStorage.removeItem(key)
  } catch (err) {
    reportWarn({
      name: 'sessionStorage.removeItem',
      global: true,
      msg: err,
    })
  }
}

export default {}
